var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongJin OH
 * @contact hjoh@detech.co.kr
 * @date 2023-10-23
 * @brief  랜딩 회원 탈퇴 컴포넌트
 *
 *
 ********************************************************************/
import { useNavigate } from "react-router-dom";
import { useRecoilState, useRecoilValue, useResetRecoilState, useSetRecoilState } from "recoil";
import { urlState } from "../../recoil/menuState";
import { myaccountMyInfo, userInfoLoginState, userInfoState } from "../../recoil/userState";
import * as HttpUtil from "../../utils/api/HttpUtil";
import * as CUTIL from "../../utils/commUtils";
import * as CONST from "../../utils/Const";
import { Trans } from "react-i18next";
import { useTrans } from "../../utils/langs/useTrans";
const UserWithdrawal = (props) => {
    const t = useTrans();
    const userInfo = useRecoilValue(userInfoLoginState);
    const [myaccountMyInfos, setMyaccountMyInfos] = useRecoilState(myaccountMyInfo);
    const resetRecoilUserInfo = useResetRecoilState(userInfoState);
    const setRecoilUrl = useSetRecoilState(urlState);
    const navigate = useNavigate();
    function onClickWithdrawal(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HttpUtil.PromiseHttp({
                httpMethod: "POST",
                appPath: `/auth/logout?userId=${userInfo.userId}`,
                appQuery: {
                    userId: userInfo.userId,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == 200) {
                    LogOut(userInfo.userId);
                }
                else {
                }
            }
        });
    }
    function LogOut(userId) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HttpUtil.PromiseHttp({
                httpMethod: "DELETEDATA",
                appPath: "/user",
                appQuery: {
                    userId: userId,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == 200) {
                    sessionStorage.removeItem(CONST.STR_TOKEN);
                    sessionStorage.removeItem(CONST.STR_TOKEN_EXPIRETIME);
                    localStorage.removeItem(CONST.STR_KEEP_LOGIN_YN);
                    localStorage.removeItem(CONST.STR_USERID);
                    localStorage.removeItem(CONST.STR_USERROLE);
                    localStorage.removeItem(CONST.STR_REFRESHTOKEN);
                    localStorage.removeItem(CONST.STR_REFRESHTOKEN_EXPIRETIME);
                    resetRecoilUserInfo();
                    setRecoilUrl(CONST.URL_MAIN);
                    navigate(CONST.URL_MAIN);
                    alert("사용자 탈퇴가 완료되었습니다.");
                    location.reload();
                }
                else {
                }
            }
        });
    }
    function Close(id) {
        if (myaccountMyInfos) {
            CUTIL.jsclose_Popup(id);
            setMyaccountMyInfos(false);
        }
        else {
            CUTIL.jsclose_InPopup(id);
        }
    }
    return (_jsx(_Fragment, { children: _jsx("div", Object.assign({ id: props.path == CONST.URL_MONITORING ? "pop-withdrawal" : "pop-withdrawal_len", className: "popup-layer js-layer layer-out inner-popup hidden popup-basic popup-withdrawal" }, { children: _jsxs("div", Object.assign({ className: "page-detail" }, { children: [_jsxs("div", Object.assign({ className: "popup__head" }, { children: [_jsx("h1", { children: t("라벨.사용자탈퇴") }), _jsx("button", Object.assign({ className: "btn btn-close ", onClick: (e) => Close("pop-withdrawal_len") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) }))] })), _jsx("div", Object.assign({ className: "popup__body" }, { children: _jsx(Trans, Object.assign({ i18nKey: "회원탈퇴" }, { children: _jsxs("p", { children: ["\uD68C\uC6D0 \uD0C8\uD1F4\uB97C \uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?", _jsx("br", {}), "\uAC00\uC785 \uC2DC \uB4F1\uB85D\uB41C \uBAA8\uB4E0 \uC815\uBCF4\uAC00 \uC0AD\uC81C\uB429\uB2C8\uB2E4."] }) })) })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray btn btn-close ", onClick: (e) => Close("pop-withdrawal_len") }, { children: _jsx("span", { children: t("라벨.취소") }) })), _jsx("button", Object.assign({ type: "button", className: " js-open", "data-pop": "pop-withdrawalcomplete", onClick: (e) => onClickWithdrawal(e) }, { children: _jsx("span", { children: t("라벨.확인") }) }))] }))] })) })) }));
};
export default UserWithdrawal;
